import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from "@angular/router";
import { LocationStrategy } from "@angular/common";
import { ComponentService } from "../../../services/component.service";
import { SharedHttp } from "../../../services/http-client.service";
/**
 * Coin Fiat Wallet Modal Component
 */
let CoinFiatWalletModalComponent = class CoinFiatWalletModalComponent {
    constructor(sanitizer, httpClient, router, location, compService, themeService) {
        this.sanitizer = sanitizer;
        this.httpClient = httpClient;
        this.router = router;
        this.location = location;
        this.compService = compService;
        this.themeService = themeService;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.addButtonClicked = false;
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
    }
    addCoin() {
        this.addButtonClicked = true;
        this.httpClient.post('wallet/createwallet', { currency: this.data.cryptoCurrency.verboseId }).subscribe((data) => {
            this.close();
        });
    }
};
CoinFiatWalletModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: SharedHttp },
    { type: Router },
    { type: LocationStrategy },
    { type: ComponentService },
    { type: WebsiteThemeService }
];
CoinFiatWalletModalComponent = __decorate([
    Component({
        selector: 'ecd-coin-fiat-wallet-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./coin-fiat-wallet-modal.component.html")).default
    })
], CoinFiatWalletModalComponent);
export { CoinFiatWalletModalComponent };
